import useHasTransitionError from 'hooks/useHasTransitionError'
import { useEffect, useRef, useState } from 'react'
import { navigate } from 'gatsby-link'

export default function useSMSTokenStep({ fireboltStep } = {}) {
  const currentFormRef = useRef()
  const mainPhone = fireboltStep?.capturedData?.main_phone || '(00) 00000-0000'
  const phoneNumber = fireboltStep?.capturedData?.phone_number
  const userTelephone = phoneNumber ? phoneNumber : mainPhone

  const { remoteErrors, hasTransitionError } = useHasTransitionError()

  const [timeToExpire, setTimeToExpire] = useState(55)
  const [token, setToken] = useState()
  const [tokenError, setTokenError] = useState('')
  const [isErrorVisible, setIsErrorVisible] = useState(false)

  useEffect(() => {
    const errorSlug = "address_not_found"
    const hasAddressError = hasTransitionError(errorSlug)
    const hasSmsTokenError = hasTransitionError('sms_token')

    if(hasAddressError) {
      return navigate('/produto/bb/erro-no-processamento')
    }
    if(hasSmsTokenError) {
      setTokenError("O código informado está incorreto, verifique e tente novamente ou solicite um novo código")
      setIsErrorVisible(true)
    }
    
  }, [remoteErrors])

  function onChangeTimerHandler(value) {
    setTimeToExpire(value)
  }

  function onCompleteTokenHandler(value, payload = {}) {
    setToken(value)
    fireboltStep?.goNextStep({ 'sms_token': value, ...payload })
  }

  function sendToken(payload = {}) {
    fireboltStep?.goNextStep({ 'sms_token': token, ...payload })
  }

  return {
    currentFormRef,
    onChangeTimerHandler,
    timeToExpire,
    onCompleteTokenHandler,
    userTelephone,
    token,
    tokenError,
    sendToken,
    isErrorVisible,
    setIsErrorVisible,
  }
}
